interface buttonType {
  action: "submit" | "button" | "reset";
  handleSubmit: any;
  text: string;
  disabled?: boolean; 
  customClass?: string;
}
export default function Button(props: buttonType) {
  return (
    <button
    type={props.action}
    onClick={props.handleSubmit}
    disabled={props.disabled}   // actually disable the button
    className={`group relative w-full flex justify-center py-2 px-4 border border-transparent 
      text-sm font-medium rounded-md text-white 
      ${props.disabled ? "bg-purple-300 cursor-not-allowed" : "bg-purple-600 hover:bg-purple-700"} 
      focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500 mt-10 
      ${props.customClass || ""}`} 
  >
    {props.text}
  </button>
  );
}





